import { SET_WITHDRAW_AMOUNT, SET_WITHDRAW_CONFIRMED, SET_WITHDRAW_PAYMENT_METHOD } from "../actions/withdraw";
import buildReducer from "./build-reducer";
import { Map } from "immutable";

let reducers = {};

reducers[SET_WITHDRAW_AMOUNT] = (state, { amount: amount }) =>
  state.set("amount", amount).remove("confirmed");

reducers[SET_WITHDRAW_CONFIRMED] = (state) =>
  state.set("confirmed", true);

reducers[SET_WITHDRAW_PAYMENT_METHOD] = (state, { paymentMethod: paymentMethod }) =>
  state.set("paymentMethod", paymentMethod);

export default buildReducer(Map(), reducers);
